import React from 'react';
import styled, { css, withTheme } from 'styled-components';
import { NavLink } from 'react-router-dom';
import RenderOnMobile from './responsive/RenderOnMobile';
import RenderOnTablet from './responsive/RenderOnTablet';
import themeResponsiveProperty from './responsive/themeResponsiveProperty';

const activeStyleMobile = {
  color: '#000',
  borderBottom: '2px solid #000',
  fontWeight: 'bolder',
};

const activeStyleTablet = {
  color: '#fff',
  borderBottom: '2px solid #fff',
};

export default withTheme(({ children, ...props }) => (
  <Item
    activeStyle={themeResponsiveProperty(activeStyleMobile, activeStyleTablet)(props)}
    exact
    replace
    {...props}
  >
    {children}
  </Item>
));

const Item = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 .75rem;
  padding: ${themeResponsiveProperty('.5rem 0 .375rem', '.75rem 0')};
  text-transform: ${themeResponsiveProperty(null, 'uppercase')};

  color: #c1c1c1;
  border-bottom: 2px solid transparent;

  ${props => props.theme.isMobile && css`
    flex: 1;
  `};
`;

// @todo 2018-06-28 Is this the right place for this style?
export const menuItemStyle = {
  display: 'flex',
  alignItems: 'center',
  margin: '0 .75rem',
  padding: '.75rem 0',
  textTransform: 'uppercase',
};
